// routes.js
import MainDashboard from 'views/admin/default';
import Configure from 'views/admin/configure';
import Interface from 'views/admin/interface';
import Logic from 'views/admin/logic';
import EditDevice from 'views/admin/editDevice';
// import TelemetryMonitor from 'views/admin/monitor';
import SignInCentered from 'views/auth/signIn';

export const routes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: <MainDashboard />,
    layout: '/admin',
  },
  {
    name: 'Configure Device',
    path: '/device/:deviceUUID/edit',
    component: <EditDevice />,
    layout: '/admin',
  },
  {
    name: 'Interfaces',
    path: '/device/:deviceUUID/interfaces',
    component: <Interface />,
    layout: '/admin',
  },
  {
    name: 'Configure',
    path: '/device/:deviceUUID/configure',
    component: <Configure />,
    layout: '/admin',
  },
  {
    name: 'Logic',
    path: '/logic',
    component: <Logic />,
    layout: '/admin',
  },

  {
    name: 'Sign In',
    path: '/sign-in',
    component: <SignInCentered />,
    layout: '/auth',
  },
];

export default routes;
